/* eslint-disable */
import {
  AccentSlidersData,
  IPatternAssets,
  Note,
  PatternDraft,
  PatternProps,
  PatternSelections,
  Topic,
} from '@/types'
import { Assets } from '@/utils/pattern-assets'
import { useEffect, useRef, useState, useMemo } from 'react'
import {
  useAddNoteTopic,
  useDeleteEgo,
  useGetTopicDetails,
  useUpdateNote,
  useUploadMedia,
  useDeletePatternTopic,
  useUpdatePatternTopic,
  useUpdateVisibility,
  useGetPermissions,
  useCreateTopic,
} from '@/hooks/api/dashboard'
import ModernAssetSelector from './components/ModernAssetSelector'
import PatternPreview from './Preview'
import { PatternContainer, PatternPreviewSlider } from './__styled'
import { useBrowserQuery, useConfirm, useLocalStorage } from '@/hooks/common'
import { toast } from 'react-hot-toast'
import {
  Badge,
  Box,
  Button,
  Chip,
  Drawer,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Slider,
  Theme,
  ThemeProvider,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
  Paper,
  CircularProgress,
  Fade,
  Stack,
  SelectChangeEvent,
  FormControl,
  MenuItem,
  CardContent,
  Card,
} from '@mui/material'

import {
  ANONYMOUS_PATTERN_DEFAULT_NAME,
  DEFAULT_ACCENT_SLIDER_DATA,
  defaultGalleryDraft,
  defaultPatternDraft,
  getDefaultDraft,
  HOME_PATH,
  isDefaultValue,
  MattingWidthRange,
  NoteType,
  PatternAssetsMap,
  PatternAssetTypesData,
  PatternNoteTypeLabels,
  PatternNoteTypes,
  PERMRESOURCE_TOPIC,
  PrivacyType,
  PrivacyTypes,
  ResourceType,
  TopicType,
} from '@/utils/constants'
//FOR DEBUG FPS, REMOVE LATER (GETENGINEOBJECT, GETSCENEOBJECT) & ENGINEINSTRUMENTATION
import { EngineInstrumentation } from '@babylonjs/core'
import { SetCurrentCategory, SetTopicType, GetEngineObject, GetSceneObject } from './renderer/main'
import { editorTheme as theme } from '@/theme'
import colors from '@/styles/colors'
import { Link } from 'react-router-dom'

import { TopicTypes } from '@/utils/constants'
import { useLocation, useNavigate } from 'react-router-dom'
import SVG from 'react-inlinesvg'

import { CBox, RBox } from '../__styled'
import {
  CheckCircleOutlineRounded,
  ChevronLeft,
  ChevronRight,
  ControlPointOutlined,
  Menu as MenuIcon,
  RemoveCircleOutlineOutlined,
  SaveOutlined,
} from '@mui/icons-material'
import { SVGS } from '@/assets/svgs'
import { ShareLink } from '@/components/ShareLink'
import { RoundedFilledButton, StyledSelect } from '@/components/StyledComponents'
import { ActionMenu, RInputModal, RModal, TagTopic } from '@/components'
import { MenuDarkTheme } from '@/styles/MenuDarkTheme'
import SaveScreenshotModal from './components/SaveScreenshotModal'
import FullScreenLoadingView from './components/FullScreenLoadingView'
import GuestBanner from './components/GuestBanner'
import {
  saveGuestPattern,
  loadGuestPattern,
  clearGuestPattern,
  checkStorageQuota,
} from '@/utils/guest-storage'
import { Canvas } from 'konva/lib/Canvas'
import { canPublishPatternTopic, getTopicNameFromTopic } from '@/utils/helper'
import PublishCheckListModal from './components/PublishCheckListModal'
import { emitAppEvent } from '@/events/eventBus'
import { AppEvents } from '@/events/eventTypes'
import ModernSettingsTabView from './components/ModernSettingsTabView'
import LoadingAnimatedView from '@/components/LoadingAnimatedView'

export const SaveModeType = {
  ScreenshotOnly: 1,
  UpdateTopic: 2,
  GoBack: 3,
  DuplicateTopic: 4,
  RestoreGuest: 5,
}

const Sidebar = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  backgroundColor: '#ffffff',
  borderRight: '1px solid #e2e8f0',
  boxShadow: 'none',
  position: 'relative',
}))

const SidebarHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  // padding: '24px 20px 20px 20px',
  padding: '11px 16px',
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #f0f0f0',
  position: 'relative',
  zIndex: 2,
}))

const SidebarContent = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: '#f8f9fa',
  position: 'relative',
}))

const SidebarScrollArea = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  position: 'relative',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#d1d5db',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#9ca3af',
    },
  },
}))

const SidebarFooter = styled(Box)(({ theme }) => ({
  padding: '20px',
  borderTop: '1px solid #f0f0f0',
  backgroundColor: '#ffffff',
  position: 'relative',
  zIndex: 2,
}))

const SettingsSection = styled(Card)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  border: '1px solid #f1f5f9',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  overflow: 'visible',
  '&:hover': {
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  },
  transition: 'box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
}))

const SectionContent = styled(CardContent)(({ theme }) => ({
  padding: '20px',
  '&:last-child': {
    paddingBottom: '20px',
  },
}))

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 600,
  color: '#1e293b',
  marginBottom: '4px',
}))

const QuickNavContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  marginTop: '4px',
  width: '100%',
  '&::before': {
    // Left gradient mask
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '32px',
    background: 'linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))',
    zIndex: 5,
    pointerEvents: 'none',
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  '&::after': {
    // Right gradient mask
    content: '""',
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '32px',
    background: 'linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))',
    zIndex: 5,
    pointerEvents: 'none',
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  '&.show-left-gradient::before': {
    opacity: 1,
  },
  '&.show-right-gradient::after': {
    opacity: 1,
  },
}))

const ScrollableChipsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  overflowX: 'auto',
  paddingBottom: '4px',
  paddingLeft: '0px', // Will be adjusted dynamically
  paddingRight: '0px', // Will be adjusted dynamically
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  scrollBehavior: 'smooth',
  width: '100%',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  transition: 'padding 0.2s ease',
}))

const ScrollArrow = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'direction',
})<{ direction: 'left' | 'right' }>(({ theme, direction }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  [direction]: '4px',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  border: '1px solid #e5e7eb',
  color: '#6b7280',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  zIndex: 10,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  opacity: 0,
  visibility: 'hidden',
  '&.visible': {
    opacity: 1,
    visibility: 'visible',
  },
  '&:hover': {
    backgroundColor: '#8b5cf6',
    borderColor: '#8b5cf6',
    color: '#ffffff',
    boxShadow: '0 4px 8px rgba(139, 92, 246, 0.25)',
    transform: 'translateY(-50%) scale(1.1)',
  },
  '&:active': {
    transform: 'translateY(-50%) scale(0.95)',
  },
  // Figma-style subtle glow
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: '-2px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, rgba(255,255,255,0.8), rgba(255,255,255,0.2))',
    zIndex: -1,
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  '&:hover::before': {
    opacity: 1,
  },
}))

const RightSideBar = styled(Box)({
  position: 'relative',
  minWidth: '342px',
  width: '342px',
  backgroundColor: 'white',
  transition: 'width 0.3s',
  '&.hidden': {
    minWidth: '0px',
    width: '0px',
    transition: 'width 0.3s',
  },
})

const ButtonClose = styled(Box)({
  width: '30px',
  height: '30px',
  borderRadius: '30px',
  position: 'absolute',
  top: 20,
  right: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #CCD4DC',
  cursor: 'pointer',
})

const enum APIStatus {
  INPROGRESS = 1,
  COMPLETED = 2,
}

export default function PatternPage() {
  const deleteTopic = useDeletePatternTopic()
  const updateTopic = useUpdatePatternTopic()
  const updateVisibility = useUpdateVisibility()
  const getPermissions = useGetPermissions()

  const theme = useTheme()
  const lessThanSmall = useMediaQuery(theme.breakpoints.down('md'))

  const [assets, setAssets] = useState<IPatternAssets>(Assets)
  const [topic, setTopic] = useState<Topic | null>(null)
  const [isError, setIsError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showAssetSelectorDrawer, setShowAssetSelectorDrawer] = useState(false)
  const [showSettingsDrawer, setShowSettingsDrawer] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState(true)
  const [selectedDisplayRight, setSelectedDisplayRight] = useState('')
  const [currentTab, setCurrentTab] = useState('')
  const [patternData, setPatternData] = useState<PatternDraft>({})
  const [textData] = useState('')
  const [draftData, setDraftData] = useState<PatternDraft | null>(null)
  const [showShareLink, setShowShareLink] = useState(false)
  const [changesCount, setChangesCount] = useState(0)
  const [showAccentSliders, setShowAccentSliders] = useState<boolean>(false)
  const [accentScale, setAccentScale] = useState<number>(0)
  const [accentTiling, setAccentTiling] = useState<number>(0)
  const [accentRotation, setAccentRotation] = useState<number>(0)
  const [printTiling, setPrintTiling] = useState<number>(0)
  const [cameraHorizontalPosition, setCameraHorizontalPosition] = useState<number>(0.5)
  const [showPublishChecklistView, setShowPublishChecklistView] = useState(false)
  const [accentSlidersData, setAccentSlidersData] = useState<AccentSlidersData>(
    DEFAULT_ACCENT_SLIDER_DATA,
  )
  const [progressMap, setProgressMap] = useState<Record<string, APIStatus>>({}) // notetype key :  status
  const entries = Object.entries(progressMap)
  const [assetSearchTerm, setAssetSearchTerm] = useState('')
  const [selectedAssets, setSelectedAssets] = useState<PatternSelections>({
    // boarder: {
    //   width: 0,
    //   type: 'square',
    // },
    matting: {
      width: 0,
    },
    clicked: false,
  })

  // When we changing matting from right panel, it also changes the selected tab, this holds the reference of prev. category before matting to keep the selection.
  const categoryBeforeMattingRef = useRef('accent')

  const { dialog: WarningApplyMattingDialog, confirm: warningApplyMatting } = useConfirm({
    title: 'Template Required',
    message:
      'Please ensure that a template is applied before adding matting, as matting requires an active template to function correctly.',
    singleAction: true,
  })

  // Scroll functionality for quick navigation
  const checkScrollButtons = () => {
    const container = scrollContainerRef.current
    const navContainer = container?.parentElement

    if (container && navContainer) {
      const hasScrolled = container.scrollLeft > 0
      const canScrollMore = container.scrollLeft < container.scrollWidth - container.clientWidth
      const hasOverflow = container.scrollWidth > container.clientWidth

      setCanScrollLeft(hasScrolled) // Only show left arrow if user has scrolled right
      setCanScrollRight(hasOverflow && canScrollMore) // Show right arrow if there's overflow and can scroll more

      // Update gradient masks and padding
      if (hasScrolled) {
        navContainer.classList.add('show-left-gradient')
        container.style.paddingLeft = '32px'
      } else {
        navContainer.classList.remove('show-left-gradient')
        container.style.paddingLeft = '0px'
      }

      if (hasOverflow && canScrollMore) {
        navContainer.classList.add('show-right-gradient')
        container.style.paddingRight = '32px'
      } else {
        navContainer.classList.remove('show-right-gradient')
        container.style.paddingRight = '0px'
      }
    }
  }

  const scrollLeft = () => {
    const container = scrollContainerRef.current
    if (container) {
      container.scrollBy({ left: -120, behavior: 'smooth' })
      setTimeout(checkScrollButtons, 300)
    }
  }

  const scrollRight = () => {
    const container = scrollContainerRef.current
    if (container) {
      container.scrollBy({ left: 120, behavior: 'smooth' })
      setTimeout(checkScrollButtons, 300)
    }
  }

  // Check scroll buttons on mount and when quickNavItems change
  useEffect(() => {
    if (topic?.topicType) {
      const quickNavItems = PatternAssetsMap[topic.topicType] ?? []
      if (quickNavItems.length > 0) {
        checkScrollButtons()
        const container = scrollContainerRef.current
        if (container) {
          container.addEventListener('scroll', checkScrollButtons)
          return () => container.removeEventListener('scroll', checkScrollButtons)
        }
      }
    }
  }, [topic?.topicType])

  useEffect(() => {
    if (currentTab != 'matting') {
      categoryBeforeMattingRef.current = currentTab
    }
  }, [currentTab])

  const [ewUser] = useLocalStorage('ewUser', null)
  const [isGuestRestore, setIsGuestRestore] = useLocalStorage('guest_restore', 0)
  console.log('isGuestRestore:', isGuestRestore)
  const query = useBrowserQuery()
  const topicID = query.get('topicID') || ''

  // Guest mode detection
  const isGuestMode = !ewUser?.userID && !topicID
  const [showGuestBanner, setShowGuestBanner] = useState(isGuestMode)
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [authModalStep, setAuthModalStep] = useState<'login' | 'signup'>('signup')
  const [showRestoreModal, setShowRestoreModal] = useState(false)
  const guestDataPendingSave = useRef<PatternDraft | null>(null)
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
  // const mode = query.get('mode')

  const uploadPhoto = useUploadMedia()
  const getTopicDetails = useGetTopicDetails()
  const createTopicNote = useAddNoteTopic()
  const updateTopicNote = useUpdateNote()
  const deleteEgos = useDeleteEgo(topicID)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const createTopic = useCreateTopic(ewUser?.userID)
  const saveMode = useRef(0) // 1 for screenshot only, 2 for update topic, 3 for goBack, 4 for duplicate
  const topicStateRef = useRef<Topic | null>(null)
  const draftDataRef = useRef<PatternDraft | null>(null)
  const screenshotFile = useRef<File | null>(null)
  const isNavigatingToAuth = useRef(false) // Track intentional auth redirects

  const [isEditMode, setIsEditMode] = useState(true) // Will be set to false for non-owners
  const [showInteractions, setShowInteractions] = useState(!isEditMode)
  const [deleteModalOpened, setDeleteModalOpened] = useState(false)
  const [renameModalOpened, setRenameModalOpened] = useState(false)
  const [duplicateModalOpened, setDuplicateModalOpened] = useState(false)
  const [showScreenshotModal, setShowSaveScreenshotModal] = useState(false)

  // Scroll state for quick navigation
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const templateChanged = useRef(false)
  const shouldRenameTopic = useRef(false)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const canvaRef = useRef<any>(null)

  const updateRendererComponent = () => {
    window.requestAnimationFrame(() => {
      if (canvaRef.current) canvaRef.current.updateRender()
    })
  }

  useEffect(() => {
    canvaRef.current?.updateOverlayStatus(isEditMode)
  }, [isEditMode])

  useEffect(() => {
    topicStateRef.current = topic
  }, [topic])

  useEffect(() => {
    console.log('🔄 draftDataRef updated:', {
      merge: draftData?.merge,
      hidden: draftData?.hidden,
      printTiling: draftData?.printTiling,
      wasNull: draftDataRef.current === null,
    })
    draftDataRef.current = draftData
  }, [draftData])

  useEffect(() => {
    initializePatternData()
  }, [])

  // Browser close/refresh warning for unsaved guest work
  useEffect(() => {
    if (!isGuestMode) return

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Skip warning if user is intentionally navigating to auth
      if (isNavigatingToAuth.current) return

      if (draftData && Object.keys(draftData).length > 1) {
        e.preventDefault()
        e.returnValue = ''
        return ''
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [isGuestMode, draftData])

  /*
  //FOR DEBUG FPS, REMOVE LATER
  console.log('🚩 BabylonPreview Component is rendering! ID:', topicID)
  useEffect(() => {
    let statsDiv: HTMLDivElement | null = null
    let updateInterval: NodeJS.Timeout
    let checkSceneReady: NodeJS.Timeout

    console.log('🔍 Stats Overlay: Waiting for Scene...')

    checkSceneReady = setInterval(() => {
      const scene = GetSceneObject()
      const engine = GetEngineObject()

      if (scene && engine) {
        clearInterval(checkSceneReady)

        console.log('✅ Stats Overlay: Scene Found! Creating HUD...')

        statsDiv = document.createElement('div')
        Object.assign(statsDiv.style, {
          position: 'fixed',
          top: '50px',
          left: '50px',
          width: '150px',
          backgroundColor: 'red',
          color: 'white',
          padding: '10px',
          fontFamily: 'monospace',
          fontSize: '14px',
          fontWeight: 'bold',
          pointerEvents: 'none',
          zIndex: '999999',
          whiteSpace: 'pre-line',
          border: '2px solid yellow',
        })

        document.body.appendChild(statsDiv)

        updateInterval = setInterval(() => {
          if (!engine || !scene) return

          let fps = '0'
          try {
            fps = engine.getFps().toFixed(0)
          } catch (e) {}

          let mem = 'N/A'
          if ((performance as any).memory) {
            mem = ((performance as any).memory.usedJSHeapSize / 1048576).toFixed(0)
          }

          statsDiv!.innerHTML = `FPS: ${fps}\nMEM: ${mem} MB\nMesh: ${scene.getActiveMeshes().length} / ${scene.meshes.length}`
        }, 500)
      }
    }, 1000)

    return () => {
      clearInterval(checkSceneReady)
      clearInterval(updateInterval)
      if (statsDiv) statsDiv.remove()
    }
  }, [topicID])
  */

  // Block back button navigation for guests with unsaved changes
  useEffect(() => {
    if (!isGuestMode) return
    if (!draftData || Object.keys(draftData).length <= 1) return

    let isNavigating = false

    const handlePopState = (e: PopStateEvent) => {
      if (isNavigating) return

      const shouldLeave = window.confirm(
        "You have unsaved changes in your pattern. They are saved locally, but leaving now means you won't be able to continue editing this session. Are you sure you want to leave?",
      )

      if (shouldLeave) {
        // Allow navigation by going back
        isNavigating = true
        window.history.back()
      } else {
        // Prevent navigation by pushing state back
        window.history.pushState(null, '', window.location.pathname)
      }
    }

    // Push a dummy state to handle back button
    window.history.pushState(null, '', window.location.pathname)

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [isGuestMode, draftData])

  /*
  useEffect(() => {
    if (createTopicNote.isSuccess && saveMode.current != 4) {
      getTopic()
    }
  }, [createTopicNote.isSuccess])
  */

  // Check for guest data after authentication - show modal instead of auto-restoring
  useEffect(() => {
    // Only check if user is authenticated and at /pattern without topicID
    if (ewUser?.userID && !topicID && pathname === '/pattern') {
      const savedGuestPattern = loadGuestPattern()

      if (savedGuestPattern && savedGuestPattern.draftData) {
        // Store data and show modal
        guestDataPendingSave.current = savedGuestPattern.draftData
        setShowRestoreModal(true)
      } else {
        // No guest data to restore, redirect authenticated user to home
        toast('Please select or create a pattern from the gallery')
        navigate(HOME_PATH)
      }
    }
  }, []) // Run once on mount

  const [showProgressBox, setShowProgressBox] = useState(false)

  const hasDataForInfoBox = useMemo(() => {
    return Object.values(progressMap).some((status) => status === APIStatus.INPROGRESS)
  }, [progressMap])

  const timeoutRef = useRef<any>(null)

  useEffect(() => {
    if (hasDataForInfoBox) {
      // show immediately
      setShowProgressBox(true)
      return
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    // delay hiding

    timeoutRef.current = setTimeout(() => {
      setShowProgressBox(false)
      setProgressMap({}) // Clear when hidden
    }, 3000)

    return () => clearTimeout(timeoutRef.current) // cancel if showInfoBox flips back to true before delay ends
  }, [hasDataForInfoBox])

  // ==================================================================================================================//

  const inProgressCount = useMemo(() => {
    return Object.values(progressMap).filter((status) => status === APIStatus.INPROGRESS).length
  }, [progressMap])

  const totalCount = Object.keys(progressMap).length
  const completedCount = totalCount - inProgressCount

  const onAssetsUpdate = (updatedAssets: IPatternAssets) => {
    setAssets(updatedAssets)
  }

  const incrementChangesCount = () => {
    setChangesCount((prev) => prev + 1)
  }
  const resetChangesCount = () => {
    setChangesCount(0)
  }

  const goBack = () => {
    // navigate(HOME_PATH)
    navigate(-1)
  }
  const onBackClick = async () => {
    // Guest users: just navigate back (work is auto-saved to localStorage)
    if (isGuestMode) {
      goBack()
      return
    }

    // Authenticated users: save changes before navigating back
    if (changesCount > 0) {
      await saveDraft()
      if (loading) return
      saveMode.current = SaveModeType.GoBack
      if (canvaRef.current) {
        canvaRef.current.saveScreenShot()
      }
    } else {
      goBack()
    }
  }

  const handleGuestSignIn = () => {
    // Save pattern data before redirecting
    if (draftData) {
      saveGuestPattern(draftData)
    }
    // Disable beforeunload warning for intentional auth redirect
    isNavigatingToAuth.current = true
    // Redirect to sign in page
    window.location.href = `/auth?step=login&redirect=${encodeURIComponent('/pattern')}`
  }

  const handleGuestRegister = () => {
    // Save pattern data before redirecting
    if (draftData) {
      saveGuestPattern(draftData)
    }
    // Disable beforeunload warning for intentional auth redirect
    isNavigatingToAuth.current = true
    // Redirect to sign up page
    window.location.href = `/auth?step=signup&redirect=${encodeURIComponent('/pattern')}`
  }

  const menuItems = useMemo(() => {
    // Guest mode: Minimal menu options
    if (isGuestMode) {
      return [
        {
          icon: null,
          name: 'Sign In to Save',
          onClick: handleGuestSignIn,
        },
        {
          icon: null,
          name: 'Close',
          onClick: () => navigate('/'),
        },
      ]
    }

    // Authenticated mode: Full menu
    if (topic != null) {
      let items = [
        {
          icon: null,
          name: 'Rename',
          onClick: () => setRenameModalOpened(true),
        },
        {
          icon: null,
          name: 'Duplicate',
          onClick: () => setDuplicateModalOpened(true),
        },
      ]

      if (topic.visibility == PrivacyType.PRIVATE.toString()) {
        items.push({
          icon: null,
          name: 'Save as Public',
          onClick: () => changeVisibility(PrivacyType.PUBLIC),
        })
      } else {
        items.push({
          icon: null,
          name: 'Make Private',
          onClick: () => changeVisibility(PrivacyType.PRIVATE),
        })
      }
      items.push({
        icon: null,
        name: 'Delete',
        onClick: () => setDeleteModalOpened(true),
      })

      items.push({
        icon: null,
        name: 'Close',
        onClick: onBackClick,
      })
      return items
    }
    return []
  }, [topic, isGuestMode])

  const isMyTopic = useMemo(() => {
    return ewUser?.userID == topic?.userID
  }, [topic, ewUser])

  // Set preview mode for logged-in users viewing others' patterns
  // Guests (not logged in) always get edit mode for their session
  useEffect(() => {
    if (topic && ewUser?.userID) {
      // Logged-in user viewing a pattern
      if (!isMyTopic) {
        // Not their pattern -> preview mode
        setIsEditMode(false)
        setShowInteractions(true)
      }
    }
    // If not logged in (guest), keep edit mode - they're creating/editing their own pattern
  }, [topic, isMyTopic, ewUser?.userID])

  useEffect(() => {
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }, [showInteractions])

  const saveDraft = async () => {
    if (!topic || !draftData) return

    console.log('Topic: ', JSON.stringify(topic))
    console.log('Draft To Save: ', JSON.stringify(draftData))

    // Local copy of notes — note: shallow copy, so we replace (not mutate) entries on update
    let localNotes = [...topic.notes]

    const relevantKeys = Object.keys(draftData).filter((draftKey) => {
      if (!PatternNoteTypes[draftKey]) {
        console.log(`⏭️ Skipping ${draftKey} - no note type mapping`)
        return false
      }
      return true
    })

    for (const draftKey of relevantKeys) {
      const draftValue = draftData[draftKey as keyof PatternDraft]
      const isDefault = isDefaultValue(draftValue, draftKey, draftData.accentID != null)
      const noteText = draftValue == null ? 'null' : JSON.stringify(draftValue)
      const noteType = PatternNoteTypes[draftKey]

      const find = localNotes.find((note) => note.noteType === noteType)

      console.log(`Draft Key: ${draftKey}, Value:`, draftValue)
      console.log(`Found:`, find)
      console.log(`Is Default Value:`, isDefault)

      try {
        // Skip add note for template, there is always id 2,
        if (!find && !isDefault && draftKey != 'templateID') {
          console.log(`➕ Creating new note for ${draftKey}:`, noteText.substring(0, 100))

          updateProgress(draftKey, APIStatus.INPROGRESS)

          const response = await createTopicNote.mutateAsync({
            topicID: topic.topicID,
            noteName: draftKey,
            noteText,
            noteType,
            egoItems: [],
          })

          if (response?.noteID) {
            const newNote: Note = {
              noteID: response.noteID,
              noteName: draftKey,
              noteText,
              noteType,
              dateCreated: response.dateCreated || new Date().toISOString(),
              dateUpdated: response.dateUpdated || new Date().toISOString(),
              authorID: ewUser?.userID || '',
              authProfileName: ewUser?.profileName || '',
              authProfileThumbURL: ewUser?.profileThumbURL || '',
              backgroundID: '',
              comments: 0,
              likes: [],
              fontID: '0',
              isThumbsDown: 0,
              isThumbsUp: 0,
              scale: '0',
              thumbsDown: '0',
              thumbsUp: '0',
              egoList: [],
              color: { r: '0', g: '0', b: '0' },
            }
            localNotes = [...localNotes, newNote]
            console.log(`✅ Added note ${response.noteID} to local notes (${draftKey})`)

            updateProgress(draftKey, APIStatus.COMPLETED)
          }
        } else if (find && find.noteText !== noteText) {
          console.log(
            `✏️ Updating note ${find.noteID} for ${draftKey}:`,
            noteText.substring(0, 100),
          )
          console.log(`   📝 Old DB value:`, find.noteText.substring(0, 150))
          console.log(`   📝 New draft value:`, noteText.substring(0, 150))
          console.log(`   📊 Draft raw value:`, draftValue)

          const updatedNote = { ...find, noteText }
          localNotes = localNotes.map((note) => (note.noteID === find.noteID ? updatedNote : note))
          await updateNote(updatedNote)
        } else {
          console.log(`✓ No changes for ${draftKey}: ${draftValue}`)
        }
      } catch (error) {
        console.error(`❌ Failed to save ${draftKey}:`, error)
        toast.error(`Failed to save ${draftKey}`)
      }
    }

    const updatedTopic = { ...topic, notes: localNotes }

    if (saveMode.current === 0) {
      setTopic(updatedTopic)
    } else {
      // topicStateRef.current = updatedTopic
    }
    topicStateRef.current = updatedTopic

    console.log('✅ saveDraft completed')
  }

  const updateProgress = (id: string, status: APIStatus) => {
    setProgressMap((prev) => ({
      ...prev,
      [id]: status,
    }))
  }

  const copyDraftToTopic = async (newTopic: Topic, newDraftData: PatternDraft) => {
    let localNotes = [...(newTopic?.notes || [])]

    const hasAccent = localNotes.some((e) => e.noteType == NoteType.ACCENT.toString())

    console.log('DraftToCopy: ', JSON.stringify(newDraftData))

    for (const draftKey in newDraftData) {
      if (!PatternNoteTypes[draftKey]) continue

      const draftValue = newDraftData[draftKey as keyof PatternDraft]
      const isDefault = isDefaultValue(draftValue, draftKey, hasAccent)
      const noteText = draftValue == null ? 'null' : JSON.stringify(draftValue)
      const noteType = PatternNoteTypes[draftKey]

      try {
        const find = localNotes.find((note) => note.noteType === noteType)
        if (!find && !isDefault && draftKey != 'templateID') {
          updateProgress(draftKey, APIStatus.INPROGRESS)

          const response = await createTopicNote.mutateAsync({
            topicID: newTopic.topicID,
            noteName: draftKey,
            noteText: noteText,
            noteType: PatternNoteTypes[draftKey],
            egoItems: [],
          })

          // Add to local notes array immediately
          if (response?.noteID) {
            const newNote: Note = {
              noteID: response.noteID,
              noteName: draftKey,
              noteText: noteText,
              noteType: PatternNoteTypes[draftKey],
              dateCreated: response.dateCreated || new Date().toISOString(),
              dateUpdated: response.dateUpdated || new Date().toISOString(),
              authorID: ewUser?.userID || '',
              authProfileName: ewUser?.profileName || '',
              authProfileThumbURL: ewUser?.profileThumbURL || '',
              backgroundID: '',
              comments: 0,
              likes: [],
              fontID: '0',
              isThumbsDown: 0,
              isThumbsUp: 0,
              scale: '0',
              thumbsDown: '0',
              thumbsUp: '0',
              egoList: [],
              color: { r: '0', g: '0', b: '0' },
            }

            updateProgress(draftKey, APIStatus.COMPLETED)
            localNotes.push(newNote)
          }
        }
      } catch (error) {
        console.error(`❌ Failed to copy ${draftKey}:`, error)
      }
    }

    setTopic({ ...newTopic, notes: localNotes })
    setDraftData({
      ...newDraftData,
    })
  }

  const onConfirmDeleteTopic = () => {
    if (topic) {
      toast.loading('Deleting...', { id: 'delete-topic' })
      deleteTopic
        .mutateAsync({ topicID: topic.topicID })
        .then((value) => {
          toast.remove('delete-topic')
          toast.success('Deleted Successfully.', { duration: 2000 })
          navigate(HOME_PATH)
        })
        .catch((e) => {
          toast.remove('delete-topic')
          toast.error(e.toString())
        })
    }
  }

  const onConfirmRenameTopic = (text: string) => {
    const currentTopicName = getTopicNameFromTopic(topic!!)
    if (topic && text != currentTopicName) {
      toast.loading('Updating...', { id: 'update-topic' })
      updateTopic
        .mutateAsync({ topic, topicName: text })
        .then((value) => {
          toast.remove('update-topic')
          toast.success('Updated Successfully.', { duration: 2000 })

          const noteText = {
            text: `<p>${text}</p>`,
            attachments: [],
          }

          let updatedTopic = {
            ...topic,
            topicName: text,
            firstNote: {
              ...topic.firstNote,
              noteText: JSON.stringify(noteText),
            },
          }
          emitAppEvent(AppEvents.TOPIC_UPDATED, { topic: updatedTopic })
          setTopic((prev) => ({ ...updatedTopic }))
        })
        .catch((e) => {
          toast.remove('update-topic')
          toast.error(e.toString())
        })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const addDraft = (data: PatternDraft) => {
    console.log('💾 addDraft called with:', {
      merge: data.merge,
      hidden: data.hidden,
      printTiling: data.printTiling,
    })

    setDraftData(data)

    // Auto-save to localStorage for guests
    if (isGuestMode && data) {
      const saveSuccess = saveGuestPattern(data)
      if (!saveSuccess) {
        const quota = checkStorageQuota()
        if (!quota.available) {
          toast.error('Storage full. Please sign up to save your design.', { duration: 5000 })
        }
      }
    }
  }

  const getTopic = async (): Promise<Topic | undefined> => {
    console.log('=============== Fetch Topic Details =================')
    setLoading(true)
    let topicData
    try {
      topicData = await getTopicDetails.mutateAsync({ topicID })
      setTopic(topicData)
      SetTopicType(topicData.topicType)
      setLoading(false)
      return topicData
    } catch (e) {
      setIsError(true)
      setLoading(false)
    }
  }

  const initializePatternData = async () => {
    // Reset changes counter on every page load
    setChangesCount(0)

    // Guest mode: Load from localStorage
    if (isGuestMode) {
      // Set topic type for renderer initialization
      SetTopicType(TopicType.PATTERN.toString())

      const savedGuestPattern = loadGuestPattern()
      if (savedGuestPattern) {
        console.log('Loaded guest pattern from localStorage')
        setDraftData(savedGuestPattern.draftData)
        setPatternData(savedGuestPattern.draftData)
        toast.success('Restored your unsaved design', { duration: 3000 })
      } else {
        // Initialize with blank canvas for guests
        const defaultDraft: PatternDraft = { templateID: 2 }
        setPatternData(defaultDraft)
        setDraftData(defaultDraft)
      }
      // Set to 'accent' tab which displays as "Template" for pattern topics
      setCurrentTab(PatternAssetsMap[TopicType.PATTERN][0].categoryName)
      setLoading(false)
      return
    }

    // Authenticated mode: Load from server
    // If no topicID, initialize with blank canvas (restore modal will handle guest data)
    if (!topicID) {
      SetTopicType(TopicType.PATTERN.toString())
      setPatternData(defaultPatternDraft)
      setDraftData(defaultPatternDraft)
      setCurrentTab(PatternAssetsMap[TopicType.PATTERN][0].categoryName)
      setLoading(false)
      return
    }

    const topic = await getTopic()
    if (!topic) return

    // To save the topic image after restore navigation
    if (isGuestRestore) {
      setTimeout(() => {
        if (canvaRef.current) {
          setIsGuestRestore(0)
          saveMode.current = SaveModeType.UpdateTopic
          topicStateRef.current = topic
          canvaRef.current.saveScreenShot()
        }
      }, 2000)
    }

    const topicName = getTopicNameFromTopic(topic)
    if (topic.notes.length == 1 && topicName == ANONYMOUS_PATTERN_DEFAULT_NAME) {
      shouldRenameTopic.current = true
    }
    // shouldRenameTopic
    setCurrentTab(PatternAssetsMap[topic.topicType][0].categoryName)
    // check if custom print, skip pattern as default selected tab,
    // const found = PatternAssetsMap[topic.topicType].some((e) => e.categoryName == 'template')
    // if (!found) {setCurrentTab(PatternAssetsMap[topic.topicType][0].categoryName)}

    const defaultTemplateID =
      topic.topicType == TopicType.PATTERN.toString()
        ? 2
        : topic.topicType == TopicType.GALLERY.toString()
          ? 400
          : 2
    const draft: PatternDraft = { templateID: defaultTemplateID }
    console.log('📥 Loading pattern from notes. Total notes:', topic.notes.length)

    const sortedNotes = [...topic.notes].sort((a, b) => {
      const dateA = a.dateUpdated || a.dateCreated || ''
      const dateB = b.dateUpdated || b.dateCreated || ''
      return dateB.localeCompare(dateA) // Fixed: Descending order
    })

    const hasAccent = sortedNotes.some((e) => e.noteType == NoteType.ACCENT.toString())
    const hasAccentScale = sortedNotes.find((e) => e.noteType == '13')
    const hasAccentNumber = sortedNotes.find((e) => e.noteType == '14')
    const hasAccentRotation = sortedNotes.find((e) => e.noteType == '15')

    if (hasAccent) {
      if (!hasAccentScale) {
        draft['accentScale'] = 1
      }

      if (!hasAccentNumber) {
        draft['accentNumber'] = 1
      }

      if (!hasAccentRotation) {
        draft['accentRotation'] = 0.001
      }
    }

    const processedNames = new Set<string>()
    sortedNotes.forEach((note: Note) => {
      if (note.noteType === '8' || note.noteType === '9' || note.noteType === '1') return

      // Fixed: Track by noteName, just like PatternPreviewPage
      if (!processedNames.has(note.noteName)) {
        processedNames.add(note.noteName)

        try {
          const parsedValue = JSON.parse(note.noteText)
          draft[note.noteName as keyof PatternDraft] = parsedValue

          if (
            note.noteName === 'merge' ||
            note.noteName === 'hidden' ||
            note.noteName === 'printTiling'
          ) {
            console.log(
              `📥 Loaded ${note.noteName} (type ${note.noteType}, noteID: ${note.noteID}):`,
              parsedValue,
            )
          }
        } catch (e) {
          console.error(`🚨 Failed to parse note ${note.noteName}:`, e)
        }
      }
    })

    console.log('📥 Final loaded draft:', {
      merge: draft.merge,
      hidden: draft.hidden,
      printTiling: draft.printTiling,
    })

    console.log('Draft AFter final Loaded: ', draft)

    setPatternData(draft)
    // NOTE: Do NOT set draftData here! Let it stay null until renderer finishes initialization
    // and calls handlePatternEdit with the ACTUAL applied state (including merges)
  }

  // Allow guest mode OR post-auth waiting state without topic
  // isGuestMode: unauthenticated users
  // !topicID: authenticated users waiting for post-auth save flow
  // Removed early return to prevent "Rendered more hooks" error
  // Loading state is handled in the JSX return below
  /*
  const onAccentChanged = (accentID: number) => {
    templateChanged.current = true
    incrementChangesCount()
    const draft: PatternDraft = {
      templateID: 2,
      accentID: accentID,
      color: {},
      print: {},
      materialID: {},
    }
    setDraftData(draft)
  }
  */

  const isResetFromAccentChange = useRef(false)
  const newAccentID = useRef<number>()

  const onAccentChanged = (accentID: number) => {
    isResetFromAccentChange.current = true
    newAccentID.current = accentID

    console.log('Before New Accent: ', newAccentID.current)
    canvaRef.current.changeTemplate(accentID)
  }

  const onTemplateChanged = () => {
    templateChanged.current = true
  }
  const onAssetSelected = (category: string, assets: PatternSelections) => {
    console.log('-------------- ON ASSET SELECTED ---------------')

    setCurrentTab(category)

    setSelectedAssets((prev) => {
      const final = { ...prev, ...assets, clicked: true }
      return final
    })
    updateRendererComponent()
  }

  const onResetSelection = () => {
    if (isResetFromAccentChange.current) {
      setSelectedAssets((prevSelectedAssets) => ({
        ...prevSelectedAssets,
        accent: newAccentID.current,
        frame: undefined,
        print: undefined,
        material: undefined,
        color: undefined,
        matting: {
          ...prevSelectedAssets.matting,
          width: 0,
        },
        clicked: false,
      }))

      isResetFromAccentChange.current = false
      newAccentID.current = undefined
    } else {
      setSelectedAssets((prevSelectedAssets) => ({
        ...prevSelectedAssets,
        accent: undefined,
        frame: undefined,
        matting: {
          ...prevSelectedAssets.matting,
          width: 0,
        },
        // patternFrame: undefined,
      }))
    }
    incrementChangesCount()
    updateRendererComponent()
    setAccentRotation(DEFAULT_ACCENT_SLIDER_DATA.rotation)
    setAccentTiling(DEFAULT_ACCENT_SLIDER_DATA.tiling)
  }

  const onClickDuplicate = () => {
    duplicatePattern()
  }

  const duplicatePattern = async () => {
    // Create Topic, with Name and type
    // Add Notes,
    const newDraftData = { ...draftData }
    if (topic != null) {
      setLoading(true)
      toast.loading('Processing', { id: 'topic-duplicate' })
      const topicName = getTopicNameFromTopic(topic)
      const result = await createTopic.mutateAsync({
        topicName: `Copy of ${topicName}`,
        topicType: topic.topicType,
        allowContribution: 0,
        topicXData: 'X Data Here',
        privacyType: PrivacyType.PRIVATE,
        cliques: [],
        connections: [],
      })
      toast.remove('topic-duplicate')

      saveMode.current = SaveModeType.DuplicateTopic
      const newTopic = await getTopicDetails.mutateAsync({ topicID: result.topicID })
      topicStateRef.current = newTopic
      setTopic((prev) => ({ ...newTopic }))
      await copyDraftToTopic(newTopic, newDraftData)
      if (canvaRef.current) {
        canvaRef.current.saveScreenShot()
      }
    }
  }

  const handleCameraHorizontalPositionChange = (event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      newValue = newValue[0]
    }
    setCameraHorizontalPosition(newValue)
    canvaRef.current.onCameraHorizontalPositionChangeRef(newValue)
  }

  const changeVisibility = (newPrivacy: PrivacyType) => {
    if (topic != null) {
      // Get Permission ID

      console.log('Topic: ', JSON.stringify(topic))

      if (changesCount > 0) {
        alert('You have unsaved changes. Please save first to continue.')
        return
      }

      if (newPrivacy == PrivacyType.PUBLIC) {
        if (!canPublishPatternTopic(topic)) {
          setShowPublishChecklistView(true)
          return
        }
      }

      const updatePerm = (permID: string) => {
        // When making public, use accessTypeID = 1 (PUBLIC/NONMEMBER)
        const actualPrivacy = newPrivacy === PrivacyType.BROADCAST ? PrivacyType.PUBLIC : newPrivacy

        updateVisibility
          .mutateAsync({
            resourceID: topic.topicID,
            cliqueTypes: topic.cliqueTypes,
            cliques: [],
            connections: [],
            accessTypeID: actualPrivacy.toString(),
            permissionID: permID,
            resourceType: PERMRESOURCE_TOPIC, // Use backend's resource type (6), not frontend's (3)
          })
          .then((value) => {
            toast.remove('perm-load')
            toast.success('Updated', { duration: 2000 })
            emitAppEvent(AppEvents.TOPIC_PRIVACY_UPDATED, {
              topic: { ...topic, visibility: newPrivacy.toString() },
            })

            setTopic({
              ...topic,
              visibility: newPrivacy.toString(),
            })
          })
          .catch((err) => {
            toast.remove('perm-load')
            toast.error(err.toString())
          })
      }

      toast.loading('Updating...', { id: 'perm-load' })
      getPermissions
        .mutateAsync(topic.topicID)
        .then((permData) => {
          const { permissionID } = permData
          updatePerm(permissionID)
        })
        .catch((err) => {
          toast.remove('perm-load')
        })
    }
  }

  const onTabSelected = (category: string) => {
    setCurrentTab(category)
    setSelectedAssets((prev) => ({ ...prev, clicked: false }))
    updateRendererComponent()
  }

  // save draft and add screenshot as a note

  const addScreenshot = (file: File) => {
    console.log('📸 addScreenshot called, saveMode:', saveMode.current)
    if (saveMode.current == SaveModeType.ScreenshotOnly) {
      canvaRef.current.getScreenShotFile(async (file: File) => {
        screenshotFile.current = file
        setShowSaveScreenshotModal(true)
      })
    } else {
      // Only save screenshot for authenticated users with a topic
      // Loading state is already managed by onClickSave/onBackClick
      if (topicStateRef.current != null) {
        addPhotoToFirstNote(topicStateRef.current)
      } else {
        console.log('⚠️ No topic to attach screenshot to')
      }
      // For guest users, do nothing (no topic to attach screenshot to)
    }
  }

  const deletePhoto = async (egoID: string) => {
    await deleteEgos.mutateAsync([egoID])
  }

  const addPhotoToFirstNote = (obj: Topic) => {
    updateProgress('screenshot', APIStatus.INPROGRESS)
    console.log('📸 addPhotoToFirstNote called - starting upload')
    let { firstNote, topicID } = obj
    uploadScreenShot().then((fileInfo) => {
      console.log('📤 Screenshot uploaded, updating note')
      if (saveMode.current != SaveModeType.ScreenshotOnly) {
        if (firstNote) {
          // first check if there was already a screenshot
          if (firstNote.egoList.length) {
            deletePhoto(firstNote.egoList[0].egoID)
          }

          const egoList = [
            {
              sequenceID: '1',
              egoID: fileInfo.egoID,
              photoAlbumURL: fileInfo.egoAlbumURL,
              photoFullURL: fileInfo.egoImageURL,
            },
          ]
          updateTopicNote
            .mutateAsync({
              noteID: firstNote.noteID,
              topicID,
              noteText: firstNote.noteText,
              egoList,
            })
            .then((value) => {
              console.log('✅ Screenshot saved, setting loading: false')
              updateProgress('screenshot', APIStatus.COMPLETED)
              resetChangesCount()
              let updatedTopic = {
                ...obj,
                firstNote: {
                  ...obj.firstNote,
                  egoList,
                },
              }
              setTopic(updatedTopic)

              emitAppEvent(AppEvents.TOPIC_UPDATED, { topic: updatedTopic })

              if (saveMode.current == SaveModeType.GoBack) {
                goBack()
              }
              // Duplicated, navigate to new topic
              else if (
                saveMode.current == SaveModeType.DuplicateTopic ||
                SaveModeType.RestoreGuest
              ) {
                query.set('topicID', topicID)
                navigate(`${pathname}?${query.toString()}`, { replace: true })
              } else if (saveMode.current == SaveModeType.RestoreGuest) {
                query.set('topicID', topicID)
                navigate(`${pathname}?${query.toString()}`, { replace: true })
                // Redirect to pattern editor with the new topic ID (full page reload)
                // window.location.href = `/pattern?topicID=${topicID}`
              }

              saveMode.current = 0
              setLoading(false)
            })
            .catch((err) => {
              console.log('❌ Screenshot upload error, setting loading: false')
              setLoading(false)
            })
        } else {
          console.log('⚠️ No firstNote, setting loading: false')
          setLoading(false)
        }
      } else {
        console.log('⚠️ saveMode == 1, setting loading: false')
        setLoading(false)
      }
    })
  }

  const handlePatternLoad = (patternProps: PatternProps) => {
    const temp = selectedAssets

    if (patternProps.currentTemplate) temp.template = patternProps.currentTemplate.id
    else temp.template = undefined
    temp.scene = patternProps.currentSceneID
    temp.accent = patternProps.currentAccentID
    temp.frame = patternProps.currentFrameID
    // temp.patternFrame = patternProps.currentPatternFrameID
    // temp.boarder.width = patternProps.boarderWidth * 100
    // temp.boarder = {
    //   ...temp.boarder,
    //   width: patternProps.boarderWidth * 100,
    //   type: patternProps.boarderType,
    // }
    temp.matting.width = patternProps.mattingWidth * 100
    temp.matting = { ...temp.matting, width: patternProps.mattingWidth * 100 }
    temp.clicked = false
    setSelectedAssets(temp)

    // Use destructuring to combine temp and selectedAssets
    const updatedAssets = {
      ...selectedAssets, // Keep the existing selectedAssets values
      ...{
        template: patternProps.currentTemplate ? patternProps.currentTemplate.id : undefined,
        scene: patternProps.currentSceneID,
        accent: patternProps.currentAccentID,
        frame: patternProps.currentFrameID,
        // boarder: {
        //   width: patternProps.boarderWidth * 100,
        //   type: patternProps.boarderType,
        // },
        matting: {
          width: patternProps.mattingWidth * 100,
        },
        clicked: false, // Explicitly set the clicked flag
      },
    }

    // Set the merged updatedAssets to state
    setSelectedAssets(updatedAssets)
  }

  const onClickShare = () => {
    setShowShareLink(true)
  }

  const onClickSave = async () => {
    if (loading) return

    // Guest mode: Show auth modal to save
    if (isGuestMode) {
      if (draftData) {
        guestDataPendingSave.current = draftData
      }
      setAuthModalStep('signup')
      setShowAuthModal(true)
      return
    }

    // Authenticated mode: Save normally
    setLoading(true)
    console.log('💾 Starting save - loading: true')
    await saveDraft()
    console.log('✅ saveDraft completed - loading should still be true')
    saveMode.current = SaveModeType.UpdateTopic
    if (canvaRef.current) {
      console.log('📸 Starting screenshot capture')
      canvaRef.current.saveScreenShot()
    }

    if (shouldRenameTopic.current) {
      shouldRenameTopic.current = false
      setRenameModalOpened(true)
    }
  }

  // Handle post-auth pattern creation for guests
  const handleGuestAuthSuccess = async () => {
    setShowAuthModal(false)

    // Wait a bit for auth to settle
    await new Promise((resolve) => setTimeout(resolve, 500))

    // Reload ewUser
    const updatedUser = localStorage.getItem('ewUser')
    if (!updatedUser) {
      toast.error('Please try again after logging in')
      return
    }

    const patternDataToSave = { ...(guestDataPendingSave.current || draftData) }

    if (!patternDataToSave) {
      toast.error('No pattern data to save')
      return
    }

    try {
      setLoading(true)
      toast.loading('Creating your pattern...', { id: 'guest-save' })

      // Create new topic
      const result = await createTopic.mutateAsync({
        topicName: ANONYMOUS_PATTERN_DEFAULT_NAME,
        topicType: TopicType.PATTERN.toString(),
        allowContribution: 0,
        topicXData: 'Created from guest session',
        privacyType: PrivacyType.PRIVATE, // Create as private by default
        cliques: [],
        connections: [],
      })

      saveMode.current = SaveModeType.RestoreGuest
      const newTopic = await getTopicDetails.mutateAsync({ topicID: result.topicID })
      topicStateRef.current = newTopic
      setTopic((prev) => ({ ...newTopic }))
      // Save all pattern data as notes
      await copyDraftToTopic(newTopic, patternDataToSave)

      // Clear guest storage
      clearGuestPattern()
      guestDataPendingSave.current = null

      toast.dismiss('guest-save')
      toast.success('Pattern saved! Redirecting...', { duration: 2000 })
      setTimeout(() => {
        setIsGuestRestore(1)
        window.location.href = `/pattern?topicID=${result.topicID}`
      }, 1000)
    } catch (error: any) {
      toast.dismiss('guest-save')
      toast.error(`Failed to sve pattern: ${error.toString()}`)
      setLoading(false)
    }
  }

  const toggleFullscreen = () => {
    // setIsFullScreen(!isFullScreen)
  }

  const handleRestoreGuestPattern = async () => {
    setShowRestoreModal(false)
    await handleGuestAuthSuccess()
  }

  const handleDiscardGuestPattern = () => {
    setShowRestoreModal(false)
    clearGuestPattern()
    guestDataPendingSave.current = null
    toast.success('Starting fresh!', { duration: 2000 })
  }

  const onAddTextElement = (type: number) => {
    setCurrentTab('text')
    if (canvaRef.current) canvaRef.current.addText(type)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handlePatternEdit = (data: Omit<PatternDraft, 'preview'>) => {
    // canvaRef.current?.updateOverlayStatus(true)

    // Only increment changes counter if data has ACTUALLY changed
    if (draftDataRef.current != null) {
      const hasChanges = JSON.stringify(data) !== JSON.stringify(draftDataRef.current)
      if (hasChanges) {
        console.log('📊 Data changed, incrementing counter')
        incrementChangesCount()
      } else {
        console.log('📊 Data unchanged, skipping counter increment')
      }
    } else {
      console.log('📊 First call, initializing draftData (no increment)')
    }

    if (templateChanged.current == true) {
      addDraft({
        ...data,
        // accentID: undefined,
        frameID: undefined,
      })

      setSelectedAssets((prev) => ({
        ...prev,
        // accent: undefined,
        frame: undefined,
        // patternFrame: undefined,
      }))
      setPatternData((prev) => ({
        ...prev,
        // accentID: undefined,
        frameID: undefined,
        patternFrameID: undefined,
      }))

      templateChanged.current = false
    } else {
      addDraft({
        ...data,
      })
    }
  }

  const onClickTakeScreenShot = () => {
    // Guest users must sign in to take screenshots
    if (isGuestMode) {
      setAuthModalStep('signup')
      setShowAuthModal(true)
      return
    }

    // Authenticated users can take screenshots
    saveMode.current = SaveModeType.ScreenshotOnly
    if (canvaRef.current) {
      canvaRef.current.saveScreenShot()
    }
  }

  const updateNote = async (note: Note) => {
    console.log('🌐 API Call - updateNote:', {
      noteID: note.noteID,
      topicID: topicID,
      noteText: note.noteText.substring(0, 200),
      noteName: note.noteName,
    })

    updateProgress(note.noteName, APIStatus.INPROGRESS)

    const result = await updateTopicNote.mutateAsync({
      noteID: note.noteID,
      topicID: topicID,
      noteText: note.noteText,
      egoList: note.egoList,
    })
    updateProgress(note.noteName, APIStatus.COMPLETED)
    console.log('✅ API Response:', result)
    return result
  }

  const getShareLink = () => {
    if (!topic) return ''
    let searchParam: URLSearchParams = new URLSearchParams()
    searchParam.set('topicID', topic.topicID)
    searchParam.set('topicType', topic.topicType)
    searchParam.delete('step')
    return `${window.location.origin}/preview?${searchParam.toString()}`
  }

  const uploadScreenShot = () => {
    return new Promise<any>((resolve, reject) => {
      if (canvaRef.current) {
        // toast.loading('Uploading...', { id: 'upload' })
        canvaRef.current.getScreenShotFile(async (file: File) => {
          const upload = await uploadPhoto.mutateAsync(file)
          // toast.dismiss('upload')
          // toast.success('Uploaded', { duration: 2000 })
          resolve(upload)
        })
      }
    })
  }

  const onTogglePreview = () => {
    setIsEditMode((prev) => !prev)
    console.log('Toggle preview : ', isEditMode)
  }

  const onRecenterCamera = () => {
    setCameraHorizontalPosition(0.5)
    canvaRef.current.onCameraHorizontalPositionChangeRef(0.5)
    //query.set('mode', mode === 'edit' ? 'preview' : 'edit')
    // navigate(`${pathname}?${query.toString()}`, { replace: true })
  }

  if (isError) {
    return (
      <Box display={'flex'} flexDirection='column' alignItems='center' pt={4}>
        <Typography align='center'>Topic not authorized</Typography>
        <Link to={`/`}>
          <Typography variant='label'>Go to Home</Typography>
        </Link>
      </Box>
    )
  }

  const quickNavItems = isGuestMode
    ? (PatternAssetsMap[TopicType.PATTERN] ?? [])
    : ((topic && PatternAssetsMap[topic.topicType]) ?? [])

  const topicTypeLabel = isGuestMode
    ? 'Pattern'
    : (topic && TopicTypes[topic.topicType]?.title) || 'Pattern'

  const handleQuickCategorySelect = (category: string) => {
    SetCurrentCategory(category)
    onTabSelected(category)
  }

  const renderSettingsDrawer = () => {
    const scene = GetSceneObject()
    const onUpdateAccentSliderData = (value: AccentSlidersData) => {
      canvaRef.current.onSliderAccentScaleChangeRef(value.scale)
      canvaRef.current.onSliderAccentNumberChangeRef(value.tiling)
      canvaRef.current.onSliderAccentRotationChangeRef(value.rotation)
      // setAccentSlidersData(value)
      setAccentScale(value.scale)
      setAccentTiling(value.tiling)
      setAccentRotation(value.rotation)
    }

    const onUpdatePrintTilingData = (value: number) => {
      canvaRef.current.onSliderPrintRotationChangeRef(value)
      setPrintTiling(value)
    }

    const mattingCategory = 'matting'
    let width = 0
    if (selectedAssets) {
      width = (selectedAssets as any)[mattingCategory].width
    }

    const handleMattingChange =
      (type: string, newValue?: number) => (event?: SelectChangeEvent) => {
        if (!selectedAssets.accent) {
          warningApplyMatting()
          let updated: PatternSelections = { ...selectedAssets }
          updated.matting.width = 0
          return
        }

        const value = newValue !== undefined ? newValue : event?.target.value

        // setSelectedAssets({
        //   ...selectedAssets,
        //   [mattingCategory]: {
        //     ...(selectedAssets as any)[mattingCategory],
        //     [type]: value,
        //   },
        // })
        // updateRendererComponent()

        onAssetSelected(mattingCategory, {
          ...selectedAssets,
          [mattingCategory]: {
            ...(selectedAssets as any)[mattingCategory],
            [type]: value,
          },
        })
      }

    return (
      <CBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          height: '100%',
          minHeight: 0,
        }}
      >
        <Box sx={{ backgroundColor: '#FFF', padding: '20px' }}>
          <Typography
            variant='h6'
            fontWeight={600}
            color='#0f172a'
            noWrap
            sx={{
              fontSize: '20px',
              lineHeight: 1.2,
              letterSpacing: '-0.025em',
              marginBottom: '6px',
            }}
          >
            {'Settings'}
          </Typography>
        </Box>

        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
          {scene && (
            <ModernSettingsTabView
              scale={Math.round(accentScale)}
              onUpdateScale={(value) =>
                onUpdateAccentSliderData({
                  tiling: accentTiling,
                  rotation: accentRotation,
                  scale: value,
                })
              }
              tiling={Math.round(accentTiling)}
              onUpdateTiling={(value) =>
                onUpdateAccentSliderData({
                  rotation: accentRotation,
                  scale: accentScale,
                  tiling: value,
                })
              }
              rotation={Math.round(accentRotation)}
              onUpdateRotation={(value) =>
                onUpdateAccentSliderData({
                  tiling: accentTiling,
                  scale: accentScale,
                  rotation: value,
                })
              }
              printTiling={printTiling}
              onUpdatePrintTiling={onUpdatePrintTilingData}
              scene={scene}
            />
          )}

          <Box sx={{ padding: '0px 20px 20px 20px' }}>
            <SettingsSection>
              <SectionContent>
                <SectionTitle>Matting Size</SectionTitle>
                <FormControl sx={{ mt: '6px' }} fullWidth>
                  <StyledSelect value={width} onChange={handleMattingChange('width') as any}>
                    {MattingWidthRange.map((w) => (
                      <MenuItem value={w} key={w}>
                        {w}
                      </MenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
              </SectionContent>
            </SettingsSection>
          </Box>
        </Box>
        <CBox
          sx={{
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            p: 2,
            mt: 1,
          }}
        >
          <RoundedFilledButton
            darkMode={false}
            onClick={onClickTakeScreenShot}
            startIcon={<SVG src={SVGS.TakeScreenshotIcon} />}
            sx={{ width: '100%' }}
          >
            {'Take Screenshot'}
          </RoundedFilledButton>

          <Badge
            showZero={false}
            badgeContent={changesCount}
            color='error'
            sx={{
              width: '100%',
              '& .MuiBadge-badge': {
                backgroundColor: '#ef4444',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: 14,
                // height: 20,
                minWidth: 20,
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(239, 68, 68, 0.4)',
                top: '50%',
                right: 40,
                transform: 'translateY(-50%)',
                display: changesCount > 0 ? 'inherit' : 'none',
              },
            }}
          >
            <RoundedFilledButton
              darkMode={false}
              startIcon={<SaveOutlined />}
              onClick={onClickSave}
              sx={{ ml: 0, width: '100%' }}
            >
              {'Save Design'}
            </RoundedFilledButton>
          </Badge>
        </CBox>
      </CBox>
    )
  }
  const renderSideBar = () => (
    <Sidebar>
      <SidebarHeader>
        <Box display='flex' alignItems='center' justifyContent='space-between' gap={1.5}>
          <Box display='flex' alignItems='center' gap={1.5} flex={1} minWidth={0}>
            <IconButton
              onClick={onBackClick}
              sx={{
                width: '40px',
                height: '40px',
                flexShrink: 0,
                backgroundColor: 'rgba(248, 250, 252, 0.8)',
                border: '1px solid rgba(226, 232, 240, 0.6)',
                borderRadius: '12px',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  backgroundColor: '#ffffff',
                  borderColor: '#cbd5e1',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                  transform: 'translateX(-2px)',
                },
                '&:active': {
                  transform: 'translateX(0)',
                },
              }}
            >
              <SVG src={SVGS.BackArrow} color='#475569' width={16} height={16} />
            </IconButton>

            <Box flex={1} minWidth={0}>
              <Typography
                variant='h6'
                fontWeight={600}
                color='#0f172a'
                noWrap
                sx={{
                  fontSize: '20px',
                  lineHeight: 1.2,
                  letterSpacing: '-0.025em',
                  // marginBottom: '6px',
                }}
              >
                {isGuestMode || !topic
                  ? ANONYMOUS_PATTERN_DEFAULT_NAME
                  : getTopicNameFromTopic(topic)}
              </Typography>
            </Box>
            {!lessThanSmall && (
              <ThemeProvider theme={MenuDarkTheme}>
                <ActionMenu
                  id='topic-item-menu'
                  type='icon'
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: -45,
                    horizontal: -16,
                  }}
                  parent={
                    <IconButton
                      size='small'
                      disableRipple
                      sx={{
                        width: '32px',
                        height: '32px',
                        flexShrink: 0,
                        backgroundColor: 'transparent',
                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          backgroundColor: '#ffffff',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        },
                      }}
                    >
                      <SVG
                        src={SVGS.MoreIcon}
                        width={18}
                        height={18}
                        style={{
                          color: 'inherit',
                          transition: 'color 0.2s ease',
                        }}
                      />
                    </IconButton>
                  }
                  actions={menuItems}
                />
              </ThemeProvider>
            )}
          </Box>

          {lessThanSmall && showAssetSelectorDrawer && (
            <IconButton
              onClick={() => setShowAssetSelectorDrawer(false)}
              size='small'
              sx={{
                borderRadius: '12px',
                border: `1px solid ${theme.palette.grey[200]}`,
                color: theme.palette.text.secondary,
              }}
            >
              <SVG src={SVGS.CloseIconColored} width={22} height={22} />
            </IconButton>
          )}
        </Box>

        {/* <OutlinedInput
          value={assetSearchTerm}
          onChange={(event) => setAssetSearchTerm(event.target.value)}
          placeholder='Search templates, elements, colors…'
          size='small'
          startAdornment={
            <InputAdornment position='start'>
              <Search
                fontSize='small'
                sx={{
                  color: '#9ca3af',
                  transition: 'color 0.2s ease',
                  paddingLeft: '0px !important',
                }}
              />
            </InputAdornment>
          }
          sx={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            fontSize: '14px',
            paddingLeft: '0px !important',
            height: '40px',
            boxShadow: 'none',
            border: '1px solid #e2e8f0',
            transition: 'all 0.2s ease',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e2e8f0',
              borderWidth: '1px',
            },
            '&:hover': {
              borderColor: '#cbd5e1',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#cbd5e1',
              },
              '& .MuiInputAdornment-root .MuiSvgIcon-root': {
                color: '#64748b',
              },
            },
            '&.Mui-focused': {
              borderColor: '#8b5cf6',
              boxShadow: '0 0 0 3px rgba(139, 92, 246, 0.1)',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#8b5cf6',
                borderWidth: '1px',
              },
              '& .MuiInputAdornment-root .MuiSvgIcon-root': {
                color: '#8b5cf6',
              },
            },
            '& .MuiOutlinedInput-input': {
              padding: '10px 14px 10px 0',
              fontSize: '14px',
              fontWeight: 400,
              color: '#1f2937',
              paddingLeft: '0 !important',
              '&::placeholder': {
                color: '#9ca3af',
                opacity: 1,
                fontWeight: 400,
              },
            },
            '& .MuiInputAdornment-root': {
              marginLeft: '12px',
              marginRight: '8px',
            },
          }}
        /> */}

        {/* Quick navigation chips - hidden for now */}
        {false && quickNavItems.length > 0 && (
          <QuickNavContainer>
            <ScrollableChipsContainer ref={scrollContainerRef}>
              {quickNavItems.map(({ categoryName }: { categoryName: string }) => (
                <Chip
                  key={categoryName}
                  label={categoryName === 'patternFrame' ? 'Frame' : categoryName}
                  onClick={() => handleQuickCategorySelect(categoryName)}
                  size='small'
                  variant='outlined'
                  sx={{
                    borderRadius: '6px',
                    textTransform: 'capitalize',
                    fontWeight: currentTab === categoryName ? 400 : 500,
                    fontSize: '12px',
                    height: '28px',
                    backgroundColor: currentTab === categoryName ? '#a570ff26' : 'transparent',
                    color: currentTab === categoryName ? '#612dae' : '#6b7280',
                    borderColor: `${
                      currentTab === categoryName ? '#8b3dff' : '#e5e7eb'
                    } !important`,
                    flexShrink: 0, // Prevent chips from shrinking
                    '&:hover': {
                      backgroundColor: currentTab === categoryName ? '#a570ff40' : '#f8fafc',
                      borderColor: `${
                        currentTab === categoryName ? '#8b3dff' : '#8b5cf6'
                      } !important`,
                      color: currentTab === categoryName ? '#612dae' : '#8b5cf6',
                    },
                  }}
                />
              ))}
            </ScrollableChipsContainer>

            {/* Overlay scroll arrows */}
            <ScrollArrow
              direction='left'
              onClick={scrollLeft}
              className={canScrollLeft ? 'visible' : ''}
            >
              <ChevronLeft fontSize='small' />
            </ScrollArrow>

            <ScrollArrow
              direction='right'
              onClick={scrollRight}
              className={canScrollRight ? 'visible' : ''}
            >
              <ChevronRight fontSize='small' />
            </ScrollArrow>
          </QuickNavContainer>
        )}
      </SidebarHeader>

      <SidebarContent>
        {isEditMode && (
          <SidebarScrollArea>
            <ModernAssetSelector
              key={currentTab || 'default'}
              defaultSelectedCategory={
                currentTab == 'matting' ? categoryBeforeMattingRef.current : currentTab
              }
              selectedAssets={selectedAssets}
              searchTerm={assetSearchTerm}
              onAssetSelected={onAssetSelected}
              onAccentChanged={onAccentChanged}
              onTemplateChanged={onTemplateChanged}
              onTabSelected={onTabSelected}
              onAddTextElement={onAddTextElement}
              topicType={topic?.topicType || TopicType.PATTERN.toString()}
              accentSlidersData={{
                scale: accentScale,
                tiling: accentTiling,
                rotation: accentRotation,
              }}
              onUpdateAccentSliderData={(value) => {
                canvaRef.current.onSliderAccentScaleChangeRef(value.scale)
                canvaRef.current.onSliderAccentNumberChangeRef(value.tiling)
                canvaRef.current.onSliderAccentRotationChangeRef(value.rotation)
                setAccentScale(value.scale)
                setAccentTiling(value.tiling)
                setAccentRotation(value.rotation)
              }}
              printTiling={printTiling}
              onUpdatePrintTilingData={(value) => {
                canvaRef.current.onSliderPrintRotationChangeRef(value)
                setPrintTiling(value)
              }}
            />
          </SidebarScrollArea>
        )}
      </SidebarContent>

      <SidebarFooter>
        <Box display='flex' alignItems='center' justifyContent='space-between' gap={2}>
          {isMyTopic && topic ? (
            <Button
              variant='contained'
              sx={{
                padding: '10px 20px',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '14px',
                textTransform: 'none',
                backgroundColor: '#1a1a1a',
                color: '#ffffff',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: '#2d2d2d',
                  boxShadow: 'none',
                },
              }}
              onClick={() => {
                changeVisibility(
                  topic.visibility == PrivacyType.PRIVATE.toString()
                    ? PrivacyType.PUBLIC
                    : PrivacyType.PRIVATE,
                )
              }}
              startIcon={
                <SVG
                  src={
                    topic.visibility == PrivacyType.PRIVATE.toString()
                      ? SVGS.FilterPrivacyPublic
                      : SVGS.FilterPrivacyPrivate
                  }
                  width={16}
                  height={16}
                />
              }
            >
              {topic.visibility == PrivacyType.PRIVATE.toString() ? 'Make Public' : 'Make Private'}
            </Button>
          ) : isMyTopic && !topic ? null : (
            <Typography variant='body2' color='text.secondary'>
              Only owners can change visibility
            </Typography>
          )}

          {topic && (
            <Button
              variant='outlined'
              onClick={onClickShare}
              startIcon={<SVG src={SVGS.ShareIcon} width={16} height={16} color='currentColor' />}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '14px',
                px: 3,
                py: '10px',
                borderColor: '#e2e8f0',
                color: '#64748b',
                boxShadow: 'none',
                '&:hover': {
                  borderColor: '#cbd5e1',
                  backgroundColor: '#f8fafc',
                  color: '#1a1a1a',
                  boxShadow: 'none',
                },
              }}
            >
              Share
            </Button>
          )}
        </Box>
      </SidebarFooter>
    </Sidebar>
  )

  // If we have a topicID but no topic yet, show loading state
  if (!topic && !isGuestMode && topicID) {
    return (
      <Box sx={{ background: 'transparent', flex: 1, paddingTop: 8 }}>
        <LoadingAnimatedView showGif={false} />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      {/* Guest Banner - Not an overlay */}
      {isGuestMode && showGuestBanner && (
        <GuestBanner
          onSignIn={handleGuestSignIn}
          onRegister={handleGuestRegister}
          onDismiss={() => setShowGuestBanner(false)}
          autoSaveEnabled={true}
        />
      )}

      <PatternContainer
        sx={{
          flexDirection: isEditMode ? 'row' : 'column',
          flex: 1,
          minHeight: 0,
        }}
      >
        {/* Rendering Header in center for preview mode */}
        {!isEditMode && (
          <IconButton
            onClick={onTogglePreview}
            sx={{ position: 'absolute', right: '10px', top: '15px', zIndex: 10 }}
          >
            <SVG src={SVGS.CloseIconColored} width={34} height={34} color='white' />
          </IconButton>
        )}
        {isEditMode && (
          <>
            {!lessThanSmall ? (
              <Drawer
                sx={{
                  width: 342,
                  flexShrink: 0,
                  zIndex: 10,
                  '& .MuiDrawer-paper': {
                    width: 342,
                    borderRight: 'none',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    ml: 0,
                    borderRadius: '0 !important', // Remove border-radius from pattern editor sidebar
                    // Push down when guest banner is visible
                    ...(isGuestMode &&
                      showGuestBanner && {
                        top: '68px', // Height of guest banner
                        height: 'calc(100vh - 68px)',
                      }),
                  },
                }}
                open={true}
                variant={'permanent'}
                anchor='left'
              >
                {renderSideBar()}
              </Drawer>
            ) : (
              <Drawer
                sx={{
                  width: '70%',
                  flexShrink: 0,
                  zIndex: 20,
                  '& .MuiDrawer-paper': {
                    border: 'none',
                    width: '70%',
                    ml: 0,
                    boxSizing: 'border-box',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    borderRadius: '0 !important', // Remove border-radius from pattern editor sidebar
                    // Push down when guest banner is visible on mobile
                    ...(isGuestMode &&
                      showGuestBanner && {
                        top: '68px',
                        height: 'calc(100vh - 68px)',
                      }),
                  },
                }}
                open={showAssetSelectorDrawer}
                variant={lessThanSmall ? 'temporary' : 'permanent'}
                onClose={() => setShowAssetSelectorDrawer(false)}
                anchor='left'
              >
                {renderSideBar()}
              </Drawer>
            )}
          </>
        )}

        {(createTopicNote.isLoading || updateTopicNote.isLoading) && (
          <Box
            position='absolute'
            zIndex={10}
            right={10}
            bottom={10}
            p={1}
            borderRadius={1}
            bgcolor='white'
          >
            <Typography px={1}>Saving Design...</Typography>
          </Box>
        )}
        {/* pattern preview - Right View */}
        <Box display='flex' flex={1} position='relative'>
          {isEditMode && (
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                height: '70px',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                backdropFilter: 'blur(16px)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                zIndex: 5,
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
              }}
            />
          )}

          {isEditMode && (
            <RBox
              sx={{
                position: 'absolute',
                left: '12px',
                top: '18px',
                zIndex: 11,
                gap: '8px',
              }}
            >
              {lessThanSmall && (
                <IconButton
                  onClick={() => setShowAssetSelectorDrawer(!showAssetSelectorDrawer)}
                  sx={{ color: colors.white }}
                >
                  <MenuIcon />
                </IconButton>
              )}

              {/* {!lessThanSmall && topic && (
                <TagTopic
                  type={`${TopicTypes[topic.topicType]?.title || 'Unknown'}`}
                  textColor='white'
                />
              )} */}
            </RBox>
          )}

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <Box display={'flex'} height={'calc(100vh - 70px)'}>
              <PatternPreview
                ref={canvaRef}
                selection={selectedAssets}
                selectedTab={currentTab}
                assets={assets}
                patternData={patternData}
                textData={textData}
                isEditMode={isEditMode}
                isPagePreview={false}
                addScreenshot={addScreenshot}
                onPatternRestore={handlePatternLoad}
                onAssetsUpdate={onAssetsUpdate}
                onToggleFullScreenMode={toggleFullscreen}
                onEdit={handlePatternEdit}
                toggleSliderVisibilityCallBack={setShowAccentSliders}
                updateSliderFromAccentScaleCallBack={setAccentScale}
                updateSliderFromAccentNumberCallBack={setAccentTiling}
                updateSliderFromAccentRotationCallBack={setAccentRotation}
                updateSliderFromPrintTilingCallBack={setPrintTiling}
                updateSliderFromCameraHorizontalCallback={setCameraHorizontalPosition}
                onResetTemplate={onResetSelection}
              />
            </Box>
            <RBox
              sx={{
                height: '70px',
                backgroundColor: '#f0f1f5',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0px 20px',
                zIndex: 20,
                borderTop: '1px solid #e2e8f0',
              }}
            >
              <RBox>
                <IconButton onClick={() => canvaRef.current.onZoomOutRef()}>
                  <RemoveCircleOutlineOutlined
                    sx={{ height: '36px', aspectRatio: 1, color: '#0d1216' }}
                  />
                </IconButton>
                <IconButton onClick={() => canvaRef.current.onZoomInRef()}>
                  <ControlPointOutlined sx={{ height: '36px', aspectRatio: 1, color: '#0d1216' }} />
                </IconButton>
              </RBox>

              <CBox mx={'3%'} flex={1} alignItems={'center'} justifyContent={'center'} pt={1.5}>
                <PatternPreviewSlider
                  defaultValue={0.5}
                  value={cameraHorizontalPosition}
                  onChange={handleCameraHorizontalPositionChange}
                  aria-label='Default'
                  valueLabelDisplay='auto'
                  min={0}
                  max={1}
                  step={0.01}
                />
                <Box color='#0d1216' fontSize='12px' fontWeight={500}>
                  Camera Horizontal Position
                </Box>
              </CBox>

              <RBox>
                {/* <IconButton onClick={onRecenterCamera}>
                  <SVG src={SVGS.PreviewIcon} color='#0d1216' width={34} height={34} />
                </IconButton> */}
                <IconButton
                  onClick={() => {
                    console.log('👁️ Toggle Preview Clicked')
                    onTogglePreview()
                  }}
                >
                  <SVG
                    src={isEditMode ? SVGS.PreviewIcon : SVGS.ExitPreviewIcon}
                    color='#0d1216'
                    width={34}
                    height={34}
                  />
                </IconButton>
              </RBox>
            </RBox>
          </Box>

          {/* <Grid
          container
          direction='column'
          position={'relative'}
          sx={{
            height: '100vh',
          }}
        >
          <Grid item flex={1}>
            <PatternPreview
              ref={canvaRef}
              selection={selectedAssets}
              selectedTab={currentTab}
              assets={assets}
              patternData={patternData}
              textData={textData}
              isEditMode={isEditMode}
              addScreenshot={addScreenshot}
              onPatternRestore={handlePatternLoad}
              onAssetsUpdate={onAssetsUpdate}
              onToggleFullScreenMode={toggleFullscreen}
              onEdit={handlePatternEdit}
            />
            <Grid item sx={{ bgcolor: '#313338', height: '96px' }}></Grid>
          </Grid>
        </Grid> */}
        </Box>
        {isEditMode && (
          <>
            {!lessThanSmall ? (
              <Drawer
                sx={{
                  width: 342,
                  flexShrink: 0,
                  zIndex: 10,
                  '& .MuiDrawer-paper': {
                    width: 342,
                    borderRight: 'none',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    ml: 0,
                    borderRadius: '0 !important', // Remove border-radius from pattern editor sidebar
                    // Push down when guest banner is visible
                    ...(isGuestMode &&
                      showGuestBanner && {
                        top: '68px', // Height of guest banner
                        height: 'calc(100vh - 68px)',
                      }),
                  },
                }}
                open={true}
                variant={'permanent'}
                anchor='right'
              >
                {renderSettingsDrawer()}
              </Drawer>
            ) : (
              <Drawer
                sx={{
                  width: '70%',
                  flexShrink: 0,
                  zIndex: 10,
                  '& .MuiDrawer-paper': {
                    border: 'none',
                    width: '70%',
                    ml: 0,
                    boxSizing: 'border-box',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    borderRadius: '0 !important', // Remove border-radius from pattern editor sidebar
                    // Push down when guest banner is visible on mobile
                    ...(isGuestMode &&
                      showGuestBanner && {
                        top: '68px',
                        height: 'calc(100vh - 68px)',
                      }),
                  },
                }}
                open={showSettingsDrawer}
                variant={lessThanSmall ? 'temporary' : 'permanent'}
                onClose={() => setShowSettingsDrawer(false)}
                anchor='right'
              >
                {renderSettingsDrawer()}
              </Drawer>
            )}
          </>
        )}
        {/* <RightSideBar className={selectedDisplayRight ? '' : 'hidden'}>
          {selectedDisplayRight && (
            <ButtonClose onClick={() => setSelectedDisplayRight('')}>
              <SVG src={CloseIcon} width={8} height={8} />
            </ButtonClose>
          )}
          {selectedDisplayRight === 'likes' && topic && (
            <Box padding='20px'>
              <Typography fontWeight={700} fontSize='20px' color='#211E1E'>
                Likes ({topic.totalLikes})
              </Typography>
            </Box>
          )}
          {selectedDisplayRight === 'comments' && topic && (
            <Box padding='20px'>
              <Typography fontWeight={700} fontSize='20px' color='#211E1E'>
                Comments ({topic.totalComments})
              </Typography>
            </Box>
          )}
          {selectedDisplayRight === 'shares' && (
            <Box padding='20px'>
              <Typography fontWeight={700} fontSize='20px' color='#211E1E'>
                Shares
              </Typography>
            </Box>
          )}
        </RightSideBar> */}
        {showShareLink && (
          <Box
            position={'absolute'}
            sx={{ left: 0, width: '400px', bottom: '16px', mx: 1, zIndex: 100 }}
          >
            <ShareLink
              link={getShareLink()}
              onClose={() => {
                setShowShareLink(false)
              }}
            />
          </Box>
        )}
        <Fade in={showProgressBox} unmountOnExit>
          <Paper
            elevation={4}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 342,
              px: 2,
              py: 1.5,
              borderRadius: 2,
              zIndex: 20000,
              minWidth: 240,
              maxHeight: 300,
              overflowY: 'auto',
            }}
          >
            <Stack spacing={1.25}>
              {entries.map(([key, status]) => {
                const isCompleted = status === APIStatus.COMPLETED
                return (
                  <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {!isCompleted ? (
                      <CircularProgress size={18} thickness={5} />
                    ) : (
                      <CheckCircleOutlineRounded color='success' sx={{ fontSize: 20 }} />
                    )}

                    <Typography
                      textTransform={'capitalize'}
                      variant='h2'
                      fontWeight={500}
                      fontSize={18}
                      noWrap
                    >
                      {`${key == 'screenshot' ? 'Screenshot' : PatternNoteTypeLabels[key]} - `}
                      <Typography variant='label' fontWeight={400} fontSize={14} noWrap>
                        {isCompleted ? 'Saved' : 'Saving...'}
                      </Typography>
                    </Typography>
                  </Box>
                )
              })}
            </Stack>
          </Paper>
        </Fade>
        {topic && (
          <RModal
            open={deleteModalOpened}
            onClose={() => setDeleteModalOpened(false)}
            title='Delete Pattern?'
            description='Are you sure you want to delete this pattern?'
            submitText='Delete'
            onSubmit={onConfirmDeleteTopic}
          />
        )}
        {topic && (
          <RModal
            open={duplicateModalOpened}
            onClose={() => setDuplicateModalOpened(false)}
            title='Duplicate Pattern?'
            description='Are you sure you want to create a copy of this pattern?'
            submitText='Duplicate'
            onSubmit={onClickDuplicate}
          />
        )}
        {topic && renameModalOpened && (
          <RInputModal
            open={renameModalOpened}
            maxLength={30}
            onClose={() => setRenameModalOpened(false)}
            title='Change Pattern Name'
            text={getTopicNameFromTopic(topic)}
            placeholder={'Enter Pattern Description'}
            description=''
            submitText='Save'
            onSubmit={onConfirmRenameTopic}
          />
        )}
        {(loading || createTopicNote.isLoading || updateTopicNote.isLoading) && (
          <FullScreenLoadingView loadingText={'Saving Design...'} />
        )}
        <SaveScreenshotModal
          file={screenshotFile.current!}
          open={showScreenshotModal}
          onClose={() => {
            setShowSaveScreenshotModal(false)
          }}
        />
        {/* Auth Modal for Guest Users */}
        {showAuthModal && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 10000,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => setShowAuthModal(false)}
          >
            <Box
              sx={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                padding: '32px',
                maxWidth: '400px',
                width: '90%',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant='h5'
                fontWeight={700}
                sx={{ marginBottom: '12px', color: '#1f2937' }}
              >
                Save Your Design
              </Typography>
              <Typography
                variant='body2'
                sx={{ marginBottom: '24px', color: '#6b7280', lineHeight: 1.6 }}
              >
                Create an account to save your pattern and access it from anywhere. Your design is
                already auto-saved locally!
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
                <Button
                  onClick={() => {
                    // Save state and redirect to signup
                    if (draftData) {
                      saveGuestPattern(draftData)
                    }
                    // Disable beforeunload warning for intentional auth redirect
                    isNavigatingToAuth.current = true
                    window.location.href = `/auth?step=signup&redirect=${encodeURIComponent(
                      '/pattern',
                    )}`
                  }}
                  variant='contained'
                  fullWidth
                  sx={{
                    backgroundColor: '#7c3aed',
                    color: '#ffffff',
                    fontWeight: 600,
                    padding: '12px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize: '15px',
                    '&:hover': {
                      backgroundColor: '#6d28d9',
                    },
                  }}
                >
                  Create Account
                </Button>
                <Button
                  onClick={() => {
                    // Save state and redirect to login
                    if (draftData) {
                      saveGuestPattern(draftData)
                    }
                    // Disable beforeunload warning for intentional auth redirect
                    isNavigatingToAuth.current = true
                    window.location.href = `/auth?step=login&redirect=${encodeURIComponent(
                      '/pattern',
                    )}`
                  }}
                  variant='outlined'
                  fullWidth
                  sx={{
                    borderColor: '#e5e7eb',
                    color: '#6b7280',
                    fontWeight: 600,
                    padding: '12px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize: '15px',
                    '&:hover': {
                      borderColor: '#d1d5db',
                      backgroundColor: '#f9fafb',
                    },
                  }}
                >
                  Sign In
                </Button>
                <Button
                  onClick={() => setShowAuthModal(false)}
                  sx={{
                    color: '#9ca3af',
                    fontWeight: 500,
                    textTransform: 'none',
                    fontSize: '14px',
                  }}
                >
                  Continue as Guest
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        {showPublishChecklistView && topic && (
          <PublishCheckListModal
            topic={topic!}
            onClose={() => setShowPublishChecklistView(false)}
          />
        )}

        {/* Restore Guest Pattern Modal */}
        {showRestoreModal && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 10000,
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                padding: '32px',
                maxWidth: '480px',
                width: '90%',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              }}
            >
              <Typography
                variant='h5'
                fontWeight={700}
                sx={{ marginBottom: '12px', color: '#1f2937' }}
              >
                🎉 Welcome back!
              </Typography>
              <Typography
                variant='body1'
                sx={{ marginBottom: '24px', color: '#6b7280', lineHeight: 1.6 }}
              >
                We found an unsaved pattern you were working on. Would you like to restore it and
                continue editing?
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
                <Button
                  onClick={handleRestoreGuestPattern}
                  variant='contained'
                  fullWidth
                  sx={{
                    backgroundColor: '#7c3aed',
                    color: '#ffffff',
                    fontWeight: 600,
                    padding: '12px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize: '15px',
                    '&:hover': {
                      backgroundColor: '#6d28d9',
                    },
                  }}
                >
                  Restore My Pattern
                </Button>
                <Button
                  onClick={handleDiscardGuestPattern}
                  variant='outlined'
                  fullWidth
                  sx={{
                    borderColor: '#e5e7eb',
                    color: '#6b7280',
                    fontWeight: 600,
                    padding: '12px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize: '15px',
                    '&:hover': {
                      borderColor: '#d1d5db',
                      backgroundColor: '#f9fafb',
                    },
                  }}
                >
                  Start Fresh
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </PatternContainer>
      <WarningApplyMattingDialog />
    </Box>
  )
}
